import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutZoneSuperRegionQuickInfo extends Layout {
    buttonZoneSuperRegionCode: Button;
    panelZoneSuperRegionQuickInfo: Panel;
    sourceZoneSuperRegion: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
